import type { ProgramSeasonV1 } from '@/modules/Entertainment/interface/Program';
import { useParams } from 'next/navigation';
import { type FC, useState } from 'react';
import {
  Flex,
  Skeleton,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
import { CardHorizontalContentItem } from '@/components/modules/CardHorizontalContentItem';
import { useGetProgramContents } from '@/modules/Entertainment/http/client/useGetProgramContents';

export const ClassesSection: FC<ClassesSectionProps> = ({
  seasons = [],
  isLoading,
}) => {
  const params = useParams<{ slug: string }>();

  const [activeSeason, setActiveSeason] = useState(seasons[0]?.id ?? '');

  const { data = [], isFetching } = useGetProgramContents({
    id: params.slug,
    season: activeSeason,
  });

  if (isLoading || isFetching) {
    return (
      <Flex flexDir="column" maxW="82.6875rem" gap="1.875rem">
        <Flex gap="4">
          <Skeleton w="10rem" h="1.875rem" />
          <Skeleton w="11.25rem" h="1.875rem" />
        </Flex>
        <Skeleton w="full" h="18.75rem" borderRadius="0.25rem" />
      </Flex>
    );
  }

  return (
    <Tabs
      display="flex"
      flexDir="column"
      gap="l"
      onChange={(idx) => setActiveSeason(seasons[idx].id)}
    >
      <TabList w="fit-content">
        {seasons.map(({ title }) => (
          <Tab key={title} fontSize="md">
            {title}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        <Flex
          flexDir="column"
          w="full"
          p="l"
          gap="l"
          bg="background.brandLight"
        >
          {data.map(({ duration, slug, title, watch }) => (
            <TabPanel key={title} p="0">
              <CardHorizontalContentItem
                key={title}
                href={`${PATHS.hubs.content}/${slug}`}
                title={title}
                duration={duration ?? ''}
                progress={watch?.percentage ?? 0}
              />
            </TabPanel>
          ))}
        </Flex>
      </TabPanels>
    </Tabs>
  );
};

type ClassesSectionProps = {
  seasons?: ProgramSeasonV1[];
  isLoading?: boolean;
};
